import IconButton from "@/components/IconButton";
import { CellContext } from "@tanstack/react-table";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";

type BaseRowType = {
  id: string;
};

type ActionCellProps<T> = {
  isEditable: boolean;
  cell: CellContext<T, unknown>;
  setOpenEditRateModal: (open: boolean) => void;
  setRowSelection: (rowSelection: any) => void;
};

export default function ActionCell<T extends BaseRowType>({
  isEditable,
  cell,
  setOpenEditRateModal,
  setRowSelection
}: ActionCellProps<T>) {
  const { isCompactLayout } = useIsCompactLayout();

  const { table, row } = cell;
  return (
    <div className="flex items-center justify-end w-8">
      {isEditable && (
        <IconButton
          name="edit"
          className="!m-0 sm:hidden sm:group-hover:inline-flex"
          tabIndex={-1}
          onClick={() => {
            const meta = table.options.meta;
            const currentIndex = row.index;
            if (isCompactLayout) {
              setOpenEditRateModal(true);
              setRowSelection({ [row.original.id]: true });
            } else {
              if (meta) {
                if (meta.editableRowIndex !== currentIndex) {
                  meta?.setEditableRowIndex?.(currentIndex);
                  const rateCell = row.getVisibleCells().find((c) => c.column.id === "rate_current_year");
                  if (rateCell) {
                    meta?.setEditableCellId?.(rateCell.id);
                  }
                } else {
                  meta?.setEditableRowIndex?.(null);
                  meta?.setEditableCellId?.(null);
                }
              }
            }
          }}
        />
      )}
    </div>
  );
}
